import { FilterSectionSelectedFilters } from "@components/Filter/FilterSectionSelectedFilters";
import { FiltersDesktop } from "@components/Filter/FiltersDesktop";
import { FiltersMobile } from "@components/Filter/FiltersMobile";
import { SearchResults } from "@components/Search/Results/SearchResults";
import {
  BackgroundContainer,
  StyledContainer,
} from "@components/Styled/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { Sections } from "@components/Sections/Sections";
import { FilterProvider } from "~/providers/FilterProvider";
import React from "react";
import tw from "twin.macro";
import { CollectionHeader } from "./CollectionHeader";
import { withCollection } from "./withCollection";

const FiltersDesktopWrapper = tw.div`
  hidden lg:block mx-midi
`;
const FiltersMobileWrapper = styledWithInvalidProps("div")(
  ({ stuck }: { stuck: boolean }) => [
    tw`block z-20 sticky top-[88px] lg:hidden transition-all duration-slow bg-neutral`,
    stuck ? `box-shadow: 0px 25px 60px 0px rgba(43,43,43,0.1)` : null,
  ],
);
const FiltersMobileSelected = tw(FilterSectionSelectedFilters)`
  lg:hidden block
`;
const HeaderContainer = tw(StyledContainer)`
  !px-zero max-w-full pt-maxi pb-maxi mx-auto
`;
const FooterContainer = tw(StyledContainer)`
  !px-zero max-w-full pb-maxi mx-auto
`;
const MainContainer = tw(StyledContainer)`
  !px-zero pb-maxi max-w-full md:pb-maxi grid grid-cols-1 lg:grid-cols-4
`;
const ResultContainer = tw.div`
  lg:col-span-3 lg:px-midi
`;

export const Collection = withCollection(
  ({
    collection,
    description,
    filterBarRef,
    filterBarStuck,
    handle,
    hideBreadcrumbAndTitle,
    paths,
    title,
    header,
    footer,
    collectionHeroBannerContent,
  }) => {
    return (
      <FilterProvider
        gender={collection.gender}
        collectionTitle={collection.title}
        hideSizeFilter={!!collection.hideSizeFilter}
      >
        <BackgroundContainer background="light">
          {!collectionHeroBannerContent &&
          header &&
          Array.isArray(header) &&
          header.length > 0 ? (
            <HeaderContainer data-testid="collection-page-header">
              <Sections page={{ content: header }} />
            </HeaderContainer>
          ) : null}
          <CollectionHeader
            paths={paths}
            title={title}
            hideBreadcrumbAndTitle={hideBreadcrumbAndTitle}
            description={description}
            collectionHeroBannerContent={collectionHeroBannerContent}
          />
          <MainContainer>
            <FiltersDesktopWrapper>
              <FiltersDesktop />
            </FiltersDesktopWrapper>
            <FiltersMobileWrapper ref={filterBarRef} stuck={filterBarStuck}>
              <FiltersMobile />
            </FiltersMobileWrapper>
            <FiltersMobileSelected layout="scroll" />
            <ResultContainer>
              <SearchResults collection={{ handle, title }} />
            </ResultContainer>
          </MainContainer>
          {footer && Array.isArray(footer) && footer.length > 0 ? (
            <FooterContainer data-testid="collection-page-footer">
              <Sections page={{ content: footer }} />
            </FooterContainer>
          ) : null}
        </BackgroundContainer>
      </FilterProvider>
    );
  },
);

export default Collection;
